import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import { validateMod11 } from "@sb1finans/components/dist/Utils";
import styled from "@emotion/styled";
import { v4 as uuid } from "uuid";

const TextInput = styled(TextField)`
  max-width: "300px";
`;

const ChargebackForm: React.FC = () => {
  const [accountNumber, setAccountNumber] = useState("");
  const [legalId, setLegalId] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string>();

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(undefined);
    setSuccess(false);
    const formData = new FormData(event.currentTarget);

    const legalId = (formData.get("legalId") as string) ?? "";
    const code = (formData.get("code") as string) ?? "";
    const accountNumber = (formData.get("accountNumber") as string) ?? "";

    const request = {
      legalId,
      code,
      accountNumber: accountNumber.replace(" ", "").replace(".", ""),
      id: uuid(),
    };
    console.log("Submit", request);

    try {
      const response = await fetch("/chargeback", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
      });
      if (response.ok) {
        const json = await response.json();
        setSuccess(true);
      } else {
        const errorResponse = await response.json();
        const err = mapError(errorResponse);
        setError(err);
        setSuccess(false);
      }
    } catch (error) {
      console.error("Error: ", error);
    }
  };

  const mapError = (errorResponse: any) => {
    const errorMessage = errorResponse.REQUEST_BODY[0]?.message;
    console.log("Error message:", errorMessage);
    if (errorMessage === "Account number is empty or invalid.") {
      return "Kontonummeret er ugyldig.";
    } else {
      return "Det oppstod en feil. Vennligst prøv igjen senere.";
    }
  };

  const onChangeAccountNumber = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const accountNumber = event.currentTarget.value;
    setAccountNumber(accountNumber);
  };

  const onChangeLegalId = (event: React.ChangeEvent<HTMLInputElement>) => {
    const legalId = event.currentTarget.value;
    setLegalId(legalId);
  };

  const isAccountNumberValid = validateMod11(accountNumber);
  const isLegalIdValid = validateMod11(legalId);

  return (
    <Stack component="form" spacing={2} onSubmit={onSubmit}>
      {success && (
        <Alert severity="info">
          Ditt kontonummer er registrert. Beløpet vil bli tilbakebetalt
          førstkommende mandag.
        </Alert>
      )}
      {error && <Alert severity="error">{error}</Alert>}
      {
        <Typography variant="body1" component="h4">
          Vi trenger noen opplysinger fra deg for å starte tilbakebetaling av
          beløp i forbindelse med korreksjon av inkassosak.
        </Typography>
      }
      <TextInput
        name="legalId"
        label="Fødsels-/ orgnummer"
        type="number"
        error={legalId.length > 5 && !isLegalIdValid}
        onChange={onChangeLegalId}
      />
      <TextInput name="code" type="number" label="Kode fra brev" />
      <TextInput
        name="accountNumber"
        type="number"
        label="Kontonummer"
        error={accountNumber.length > 2 && !isAccountNumberValid}
        onChange={onChangeAccountNumber}
      />
      <Button type="submit" variant="contained">
        Bekreft
      </Button>
    </Stack>
  );
};

export default ChargebackForm;
